/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/prop-types */
/*
Author: Gilang Romadhanu Tartila
*/

import React, { useState, useEffect } from 'react';
import SociollaText from '@components/sociolla/SociollaText';
import SociollaTabs from '@components/sociolla/SociollaTabs';
import Colors from '@global/colors';
import Button from '@components/form/Button';
import TeamMember from '@components/global/TeamMember';
import ItemDetail from '@components/global/ItemDetail';
import * as Layout from '@components/screen/Layout';
import { isWeb } from '@global/screens';
import { hasNoAccess } from '@global/helpers';
import ScrollContainer from '@components/global/ScrollContainer';

import useApi from '@/hooks/useApi';
import { MsB2b } from '@api/ms-b2b';

const SalesTeamDetailScreen = (props) => {
  const [activeTab, setActiveTab] = useState(1);
  const [detailData, setDetailData] = useState({});
  const hasAccess = hasNoAccess([
    'regional_manager',
    'regional_support',
    'key_account_manager',
    'group_key_account_manager',
    'national_key_account_manager',
    'distributor_manager',
    'general_manager',
    'vice_president',
    'regional_distributor_manager',
  ]);

  const getSalesTeamDetail = useApi(MsB2b.getSalesTeamDetail);
  const tabs = [
    { value: 1, label: 'Detail' },
    { value: 2, label: 'Team Member' },
  ];

  const getDetail = async (id) => {
    const response = await getSalesTeamDetail.request(id);
    if (response?.data?.data && Object.keys(response.data.data).length) {
      setDetailData(response.data.data);
    } else {
      setDetailData({});
    }
  };

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      setActiveTab(1);
      setDetailData({});
      if (props?.route?.params?.id) {
        getDetail(props.route.params.id);
      }
    }
    return () => {
      mounted = false;
    };
  }, [props]);

  return (
    <Layout.Container>
      {isWeb ? (
        <Layout.Back
          title="Sales Team"
          onCallback={() => props.navigation.navigate('SalesTeamScreen')}
        />
      ) : (
        false
      )}
      <Layout.Wrapper rounded>
        {getSalesTeamDetail && getSalesTeamDetail.loading ? (
          <Layout.Loader />
        ) : detailData && Object.keys(detailData).length ? (
          <>
            {!isWeb ? (
              <SociollaTabs
                data={tabs}
                tabActive={activeTab}
                setTabActive={(val) => setActiveTab(val)}
              />
            ) : (
              false
            )}
            <Layout.ScrollViewRefresher
              onCallback={() => getDetail(props?.route?.params?.id)}>
              {isWeb ? (
                <Layout.Title
                  title={detailData.name}
                  style={{
                    paddingTop: 20,
                    paddingHorizontal: 25,
                  }}>
                  {hasAccess ? (
                    <Button
                      type="primary"
                      rounded={true}
                      buttonStyle={{ width: 100 }}
                      title={
                        <SociollaText
                          type="bold"
                          style={{ fontSize: 14, color: Colors.white }}>
                          Edit
                        </SociollaText>
                      }
                      onPress={() =>
                        props.navigation.navigate('SalesTeamFormScreen', {
                          titleScreen: detailData.name,
                          name: detailData.name,
                          id: detailData._id,
                        })
                      }
                    />
                  ) : (
                    false
                  )}
                </Layout.Title>
              ) : (
                false
              )}
              {isWeb || activeTab == 1 ? (
                <ScrollContainer
                  style={{
                    width: isWeb ? 400 : '100%',
                    paddingBottom: 15,
                    paddingHorizontal: isWeb ? 25 : 15,
                  }}>
                  <ItemDetail
                    name="Description"
                    value={detailData.name ? detailData.name : '-'}
                  />
                  <ItemDetail
                    name="Market Type"
                    value={
                      detailData.market_type && detailData.market_type.code
                        ? detailData.market_type.code
                        : '-'
                    }
                  />
                  <ItemDetail
                    name="Warehouse"
                    value={
                      detailData?.warehouse && detailData?.warehouse?.name
                        ? detailData?.warehouse?.name
                        : '-'
                    }
                  />
                  <ItemDetail
                    name="Optional Warehouse"
                    value={
                      detailData.optional_warehouse &&
                      detailData.optional_warehouse.length
                        ? detailData.optional_warehouse.map((item) => {
                            return item.name;
                          })
                        : '-'
                    }
                  />

                  <ItemDetail
                    name="Payment Method"
                    value={
                      detailData.payment_method
                        ? detailData.payment_method
                        : '-'
                    }
                  />
                  <ItemDetail
                    name="Short Code"
                    value={detailData.short_code ? detailData.short_code : '-'}
                  />
                  <ItemDetail
                    name="Is Active"
                    value={detailData.is_active ? 'Active' : 'Inactive'}
                  />
                </ScrollContainer>
              ) : (
                false
              )}
              {isWeb || activeTab == 2 ? (
                <TeamMember
                  data={
                    detailData &&
                    detailData.team_members &&
                    detailData.team_members.length
                      ? detailData.team_members.map((item) => {
                          item.sales_team = detailData.name;
                          return item;
                        })
                      : []
                  }
                />
              ) : (
                false
              )}
            </Layout.ScrollViewRefresher>
          </>
        ) : (
          <SociollaText style={{ fontSize: 13, color: Colors.grey1 }}>
            Sales team not found.
          </SociollaText>
        )}
      </Layout.Wrapper>
    </Layout.Container>
  );
};

export default SalesTeamDetailScreen;
